import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { PlacementsCheckListResponce, CheckListData } from 'features/PlacementsStatus/types';

interface IPlacementsCheckListStore {
  loading: boolean;
  checkListData: CheckListData[];
}

const initialState: IPlacementsCheckListStore = {
  checkListData: [],
  loading: false,
};

const reset: CaseReducer<IPlacementsCheckListStore> = () => initialState;

const placementsCheckList: CaseReducer<
  IPlacementsCheckListStore,
  PayloadAction<CheckListData[]>
> = (state, action) => {
  state.checkListData = action.payload;
};

const loading: CaseReducer<IPlacementsCheckListStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

export const placementsCheckListSlice = createSlice({
  name: 'placementsCheckList',
  initialState,
  reducers: {
    loading: loading,
    placementsCheckList,
    reset,
  },
});

const { loading: setCheckListLoading, placementsCheckList: setPlacementsCheckList } =
  placementsCheckListSlice.actions;

export const getPlacementsCheckList = (): AppThunk => {
  return dispatch => {
    dispatch(setCheckListLoading(true));

    get<PlacementsCheckListResponce>('api/standards/izs-check-lists/')
      .then(({ data }) => {
        const { results } = data;
        dispatch(setPlacementsCheckList(results));
      })
      .finally(() => dispatch(setCheckListLoading(false)));
  };
};
